import React, { useEffect } from "react";
import { Input, Upload } from "../../../../components/Form";
import Tabs from "../../../../components/Tabs";
import ImagecollectionLayout from "../../../../components/Layout/ImageCollection";
import { getMessage } from "../../../../lib/translator";
import { Radio } from "../../../../components/Form";
import LayoutVisibility from "./HelperComponents/LayoutVisibility";

const ImageCollection = (props) => {
  const { getState, updateState, parent } = props;

  const activeIndex = Number(getState(["activeIndex"])) || 0;
  const emptySlide = {
    imageUrl: "",
    text: "",
    link: "",
  };
  const slides = getState(["images"]) || [emptySlide];
  const currentSlide = slides[activeIndex] || emptySlide;

  if (!getState(["images"])) {
    updateState(["images"], slides); // TODO: Move this to componentWillMount of layout
  }

  // Since updateStateRecursively had some issues with this structure
  const newState = (key, value) => {
    parent.setState((prevState) => {
      const newState = Object.assign({}, prevState);
      newState.values.images[activeIndex][key] = value;
      return prevState;
    });
  };
  const showDelete = slides && slides.length > 1;

  useEffect(() => {
    if (!getState(["layoutType"])) {
      updateState(["layoutType"], "GRID");
    }
    if (!getState(["loadMoreType"])) {
      updateState(["loadMoreType"], "INFINITE");
    }
    // eslint-disable-next-line
  }, [slides]);
  return (
    <>
      <div className="form-sections">
        <div className="form-section">
          <Input
            label="title"
            placeholder="Please enter title here"
            value={getState(["title"]) || ""}
            onChange={(value) => {
              updateState(["title"], value);
            }}
          />
          <Radio
            name="layoutType"
            label={getMessage("themes.layoutType")}
            required
            options={[
              {
                text: getMessage("themes.grid"),
                value: "GRID",
              },
              {
                text: getMessage("themes.scroller"),
                value: "SCROLLER",
              },
            ]}
            value={getState(["layoutType"]) || ""}
            onChange={(value) => {
              updateState(["layoutType"], value);
            }}
          />
        </div>
        <div className="form-section">
          <Input
            label="subtitle"
            placeholder="Please enter subtitle here"
            value={getState(["subtitle"]) || ""}
            onChange={(value) => {
              updateState(["subtitle"], value);
            }}
          />
          <Radio
            name="pagination"
            label={getMessage("themes.loadMoreImageType")}
            required
            options={[
              {
                text: getMessage("themes.infiniteScroll"),
                value: "INFINITE",
              },
              {
                text: getMessage("themes.seeAll"),
                value: "SEEALL",
              },
            ]}
            value={getState(["loadMoreType"]) || ""}
            onChange={(value) => {
              updateState(["loadMoreType"], value);
            }}
          />
        </div>
      </div>
      <div>
        <div className="flex-around">
          <Tabs
            items={slides.map((slide, index) => (
              <span key={index}>
                image {index + 1}
                {showDelete && (
                  <span
                    className="delete-tab"
                    onClick={() => {
                      slides.splice(index, 1);
                      updateState(
                        ["activeIndex"],
                        index !== 0 && index === slides.length
                          ? index - 1
                          : index
                      );
                    }}
                  >
                    &times;
                  </span>
                )}
              </span>
            ))}
            default={activeIndex}
            active={activeIndex}
            onClick={(value) => {
              updateState(["activeIndex"], value);
            }}
          />
          <button
            className="add-tab"
            onClick={(e) => {
              e.preventDefault();
              const slidesCount = slides.length;
              updateState(["images"], slides.concat(emptySlide));
              updateState(["activeIndex"], slidesCount);
            }}
          >
            + {getMessage("imageCollection.addImage")}
          </button>
        </div>
        <div className="form-sections image-with-text-layout">
          <div className="form-section">
            <Input
              label="link"
              placeholder="Enter your link"
              value={currentSlide["link"]}
              onChange={(value) => {
                newState("link", value);
              }}
            />
            <Input
              label="text"
              placeholder="Enter your description here"
              value={currentSlide["text"]}
              onChange={(value) => {
                newState("text", value);
              }}
            />
            <div className="layout-visibility-inside-other-layouts">
              <LayoutVisibility
                stateKey="allowedPlatforms"
                getState={getState}
                updateState={updateState}
                {...props}
              />
            </div>
          </div>
          <div className="form-section">
            <Upload
              label="image"
              placeholder="Click here to upload or drag your banners"
              value={currentSlide["imageUrl"]}
              onChange={(value) => {
                newState("imageUrl", value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
const ImageCollectionWrp = () => {
  return {
    preview: ImagecollectionLayout,
    fields: ({ getState, updateState, parent }) => (
      <ImageCollection
        getState={getState}
        updateState={updateState}
        parent={parent}
      />
    ),
  };
};

export default ImageCollectionWrp;
